/* FRAME theme. Plain JavaScript, no libraries. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CFG = window.FRAME || { routes: {}, strings: {} };
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var S = {};

  /* ---------- scroll: progress bar, header state, buy bar, steps line, story ---------- */
  function onScroll() {
    var y = window.scrollY;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (S.prog) S.prog.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
    if (S.hdr) S.hdr.classList.toggle('scrolled', y > 20);

    if (S.sticky && S.hero) {
      var inShop = false;
      if (S.shop) {
        var sr = S.shop.getBoundingClientRect();
        inShop = sr.top < window.innerHeight * 0.6 && sr.bottom > window.innerHeight * 0.3;
      }
      var show = y > S.hero.offsetHeight * 0.7 && !inShop;
      S.sticky.classList.toggle('show', show);
      S.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (S.steps) {
      var r = S.steps.getBoundingClientRect();
      S.steps.style.setProperty('--p', Math.min(1, Math.max(0, (window.innerHeight * 0.7 - r.top) / r.height)));
    }

    if (S.lead && S.words && S.words.length) {
      var lr = S.lead.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (window.innerHeight * 0.85 - lr.top) / (lr.height + window.innerHeight * 0.35)));
      var n = Math.round(p * S.words.length);
      for (var i = 0; i < S.words.length; i++) S.words[i].classList.toggle('on', RM || i < n);
    }
    if (S.about && S.giant && !RM) {
      var a = S.about.getBoundingClientRect();
      if (a.bottom > 0 && a.top < window.innerHeight) S.giant.style.setProperty('--gx', (a.top * 0.25) + 'px');
    }
  }
  var ticking = false;
  function requestScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; onScroll(); });
  }

  /* ---------- reveal on scroll ---------- */
  var io = null;
  function initReveal() {
    var els = $$('.rv:not(.in)');
    if (!('IntersectionObserver' in window) || DESIGN) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    io = io || new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (el) { if (!el.dataset.rvo) { el.dataset.rvo = '1'; io.observe(el); } });
  }

  /* ---------- price count-up (the real price is already in the HTML) ---------- */
  var cio = null;
  function finish(el) { el.textContent = el.dataset.final || String(Math.round(+el.dataset.count)); }
  function count(el) {
    var to = +el.dataset.count;
    if (RM || isNaN(to)) { finish(el); return; }
    var t0 = performance.now();
    (function f(n) {
      var k = Math.min(1, (n - t0) / 1400);
      el.textContent = Math.round(to * (1 - Math.pow(1 - k, 4)));
      if (k < 1) requestAnimationFrame(f); else finish(el);
    })(t0);
  }
  function initCounts() {
    var els = $$('[data-count]:not([data-cio])');
    if (!('IntersectionObserver' in window) || RM || DESIGN) { els.forEach(function (e) { e.dataset.cio = '1'; finish(e); }); return; }
    cio = cio || new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { count(e.target); cio.unobserve(e.target); } });
    });
    els.forEach(function (el) { el.dataset.cio = '1'; el.textContent = '0'; cio.observe(el); });
  }

  /* ---------- hero: tilt, shutter flash ---------- */
  function initHero() {
    var art = $('#art');
    if (!art || art.dataset.ready) return;
    art.dataset.ready = '1';
    var tilt = $('#tilt');
    if (!RM && art.dataset.tilt === 'true' && tilt) {
      art.addEventListener('pointermove', function (e) {
        var b = art.getBoundingClientRect();
        var x = (e.clientX - b.left) / b.width - 0.5, y = (e.clientY - b.top) / b.height - 0.5;
        tilt.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 12) + 'deg) translate(' + (x * 10) + 'px,' + (y * 8) + 'px)';
      });
      art.addEventListener('pointerleave', function () { tilt.style.transform = ''; });
    }
    var btn = $('#shutter');
    if (btn) {
      var shots = 0;
      btn.addEventListener('click', function () {
        var f = $('#flash'), c = $('#shots');
        if (f) { f.classList.remove('go'); void f.offsetWidth; f.classList.add('go'); }
        shots++;
        if (c) c.textContent = String(shots + 1).padStart(4, '0');
      });
    }
  }

  /* ---------- spotlight + magnetic ---------- */
  function initSpotlight() {
    if (RM || document.body.dataset.fxSpotlight === 'false') return;
    $$('.moment:not([data-spot])').forEach(function (c) {
      c.dataset.spot = '1';
      c.addEventListener('pointermove', function (e) {
        var b = c.getBoundingClientRect();
        c.style.setProperty('--mx', (e.clientX - b.left) + 'px');
        c.style.setProperty('--my', (e.clientY - b.top) + 'px');
      });
    });
  }
  function initMagnetic() {
    if (RM || document.body.dataset.fxMagnetic === 'false') return;
    $$('[data-mag]:not([data-magr])').forEach(function (b) {
      b.dataset.magr = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.18) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.3) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- word-by-word story reveal ---------- */
  function initStory() {
    var lead = $('#lead');
    if (!lead || lead.dataset.ready) return;
    lead.dataset.ready = '1';
    var words = lead.textContent.trim().split(/\s+/);
    lead.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'w' + (RM ? ' on' : '');
      s.textContent = w;
      lead.appendChild(s);
      if (i < words.length - 1) lead.appendChild(document.createTextNode(' '));
    });
  }

  /* ---------- mobile menu ---------- */
  function closeMenu() {
    var nav = $('#nav'), mb = $('#menuBtn');
    if (!nav || !mb) return;
    nav.classList.remove('open');
    mb.setAttribute('aria-expanded', 'false');
    mb.textContent = mb.dataset.labelOpen || CFG.strings.menu_open || 'Menu';
  }
  function initMenu() {
    var nav = $('#nav'), mb = $('#menuBtn');
    if (!nav || !mb || mb.dataset.ready) return;
    mb.dataset.ready = '1';
    mb.addEventListener('click', function () {
      var o = nav.classList.toggle('open');
      mb.setAttribute('aria-expanded', String(o));
      mb.textContent = o ? (mb.dataset.labelClose || 'Close') : (mb.dataset.labelOpen || 'Menu');
    });
    $$('#nav a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  /* ---------- greeting ---------- */
  function initGreeting() {
    var g = $('[data-greet]');
    if (!g || g.dataset.ready) return;
    g.dataset.ready = '1';
    var h = new Date().getHours();
    var word = h < 12 ? g.dataset.morning : h < 18 ? g.dataset.afternoon : g.dataset.evening;
    if (word) g.textContent = word + '. ' + g.textContent;
  }

  /* ---------- moment picker ---------- */
  function initMoments() {
    var chips = $('#mchips');
    if (!chips || chips.dataset.ready) return;
    chips.dataset.ready = '1';
    var panel = $('#mpanel'), art = $('#mart');
    if (!panel || !art) return;
    function pick(k) {
      $$('button[data-k]', chips).forEach(function (b) {
        var on = +b.dataset.k === k;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', String(on));
        if (on) {
          art.style.setProperty('--rot', b.dataset.rot);
          art.style.setProperty('--b1', b.dataset.b1);
          art.style.setProperty('--b2', b.dataset.b2);
          art.style.setProperty('--ox', b.dataset.ox);
          art.style.setProperty('--oy', b.dataset.oy);
        }
      });
      $$('[data-panel]', panel).forEach(function (p) { p.hidden = +p.dataset.panel !== k; });
      $$('[data-media]', art).forEach(function (m) { m.hidden = +m.dataset.media !== k; });
      panel.classList.remove('swap'); void panel.offsetWidth; panel.classList.add('swap');
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-k]');
      if (b) pick(+b.dataset.k);
    });
  }

  /* ---------- delivery bars fill when visible ---------- */
  var dio = null;
  function initDeliver() {
    var els = $$('.deliver:not(.in)');
    if (!('IntersectionObserver' in window) || DESIGN) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    dio = dio || new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); dio.unobserve(e.target); } });
    }, { threshold: 0.3 });
    els.forEach(function (d) { if (!d.dataset.dio) { d.dataset.dio = '1'; dio.observe(d); } });
  }

  /* ---------- contact form: validation, then a normal Shopify POST ---------- */
  function initContact() {
    var form = $('[data-contact-form]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var rules = {
      name: function (v) { return v.trim().length > 1; },
      email: function (v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); },
      message: function (v) { return v.trim().length >= 10; }
    };
    form.addEventListener('submit', function (e) {
      var first = null;
      $$('[data-validate]', form).forEach(function (inp) {
        var k = inp.dataset.validate;
        var ok = rules[k](inp.value);
        var box = inp.closest('.field');
        var err = $('#ContactForm-' + k + '-err');
        if (box) box.classList.toggle('bad', !ok);
        if (err) {
          err.textContent = ok ? '' : (form.dataset['err' + k.charAt(0).toUpperCase() + k.slice(1)] || '');
          inp.setAttribute('aria-describedby', err.id);
        }
        inp.setAttribute('aria-invalid', String(!ok));
        if (!ok && !first) first = inp;
      });
      if (first) { e.preventDefault(); first.focus(); }
    });
    var okBox = $('[data-form-success]', form);
    if (okBox) okBox.focus();
  }

  /* ---------- hero shader: lazy, optional, never blocks ---------- */
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  function rgb(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    if (!m) return [0.72, 0.78, 0.62];
    var n = parseInt(m[1], 16);
    return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
  }
  function initShader() {
    var canvases = $$('[data-shader]:not([data-ready])');
    if (!canvases.length) return;
    canvases.forEach(function (c) { c.dataset.ready = '1'; });
    var nav = navigator, skip = '';
    if (nav.connection && nav.connection.saveData) skip = 'data saver is on';
    else if (nav.deviceMemory && nav.deviceMemory <= 2) skip = 'low device memory';
    else if (nav.hardwareConcurrency && nav.hardwareConcurrency <= 2) skip = 'low CPU core count';
    if (skip) { if (window.console) console.info('[FRAME shader] skipped: ' + skip); return; }
    function start() {
      var go = function () {
        if (!window.FRAME_SHADER) return;
        canvases.forEach(function (c) {
          var bg = c.hasAttribute('data-bg');
          window.FRAME_SHADER.start(c, {
            color: rgb(c.dataset.color),
            scale: +c.dataset.scale || 0.5,
            mode: bg ? 'field' : 'hero',
            gain: bg ? 0.55 : 1,
            premultiply: bg,
            still: RM
          });
        });
      };
      if (window.FRAME_SHADER) go(); else loadScript(canvases[0].dataset.src).then(go).catch(function () {
        if (window.console) console.info('[FRAME shader] could not load frame-shader.js');
      });
    }
    function schedule() {
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 3000 });
      else setTimeout(start, 1500);
    }
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  /* ---------- exact anchor scrolling (header links, sticky bar, any #link) ---------- */
  function goTo(hash, smooth) {
    var id = decodeURIComponent((hash || '').slice(1));
    if (!id) return false;
    var el = document.getElementById(id);
    if (!el) return false;
    var target = el.tagName === 'SECTION' ? ($('.inner', el) || el) : el;
    var hdr = $('[data-site-header]');
    var y = target.getBoundingClientRect().top + window.scrollY - (hdr ? hdr.offsetHeight : 0) - 24;
    window.scrollTo({ top: Math.max(0, y), behavior: smooth && !RM ? 'smooth' : 'auto' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var u;
    try { u = new URL(a.href, window.location.href); } catch (err) { return; }
    if (u.origin !== window.location.origin || u.pathname !== window.location.pathname || u.hash.length < 2) return;
    if (goTo(u.hash, true)) {
      e.preventDefault();
      history.pushState(null, '', u.hash);
      closeMenu();
    }
  });
  window.addEventListener('hashchange', function () { goTo(window.location.hash, true); });
  window.addEventListener('load', function () {
    if (window.location.hash.length > 1) setTimeout(function () { goTo(window.location.hash, false); }, 60);
  });

  /* ---------- product page: variant price ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex], price = $('[data-pdp-price]');
    if (opt && price && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  /* ---------- cart ---------- */
  var lastFocus = null;
  function drawerEl() { return $('[data-cart-drawer]'); }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n === 0) el.setAttribute('data-zero', ''); else el.removeAttribute('data-zero');
    });
  }
  function openDrawer() {
    var d = drawerEl();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.setAttribute('data-open', '');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('drawer-open');
    setTimeout(function () {
      var f = $('[data-drawer-close]', $('.drawer__panel', d)) || $('.drawer__panel', d);
      if (f) f.focus();
    }, 60);
    return true;
  }
  function closeDrawer() {
    var d = drawerEl();
    if (!d || !d.hasAttribute('data-open')) return;
    d.removeAttribute('data-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderDrawer(html) {
    var d = drawerEl();
    if (!d || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-inner]', doc);
    var inner = $('[data-cart-inner]', d);
    if (!fresh || !inner) return false;
    inner.innerHTML = fresh.innerHTML;
    var src = $('[data-cart-count-source]', fresh);
    if (src) setCount(+src.dataset.cartCountSource || 0);
    return true;
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-frame-add]');
    if (!f) return;
    e.preventDefault();
    var btn = $('[type=submit]', f), label = btn && $('span', btn), old = label && label.textContent;
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; if (label && CFG.strings.adding) label.textContent = CFG.strings.adding; }
    var d = drawerEl(), useDrawer = CFG.cartType !== 'page' && !!d;
    var fd = new FormData(f);
    if (useDrawer) { fd.append('sections', d.dataset.sectionId); fd.append('sections_url', window.location.pathname); }
    var msg = $('.form-errors', f);
    if (msg) msg.remove();
    fetch(CFG.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || '');
        if (!useDrawer) { window.location.href = CFG.routes.cart; return; }
        var html = res.j.sections && res.j.sections[d.dataset.sectionId];
        if (renderDrawer(html)) openDrawer(); else window.location.href = CFG.routes.cart;
      })
      .catch(function (err) {
        var m = document.createElement('p');
        m.className = 'form-errors';
        m.setAttribute('role', 'alert');
        m.textContent = err && err.message ? err.message : CFG.strings.error;
        f.appendChild(m);
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; if (label && old) label.textContent = old; }
      });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var chg = t.closest('[data-cart-change]');
    if (chg) {
      var d = drawerEl();
      if (!d) return;
      chg.disabled = true;
      fetch(CFG.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +chg.dataset.line, quantity: +chg.dataset.qty, sections: d.dataset.sectionId, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j.sections && j.sections[d.dataset.sectionId];
          if (!renderDrawer(html)) window.location.reload();
        })
        .catch(function () { window.location.reload(); });
      return;
    }
    var opener = t.closest('[data-cart-open]');
    if (opener && CFG.cartType !== 'page' && drawerEl()) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); }
    if (e.key === 'Tab') {
      var d = $('[data-cart-drawer][data-open]');
      if (!d) return;
      var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', $('.drawer__panel', d))
        .filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- boot ---------- */
  function init() {
    S.prog = $('#progress'); S.hdr = $('[data-site-header]'); S.sticky = $('#sticky');
    S.shop = $('#shop'); S.steps = $('#steps'); S.hero = $('[data-hero]');
    S.lead = $('#lead'); S.giant = $('.giant'); S.about = $('#about');
    initReveal(); initCounts(); initHero(); initSpotlight(); initMagnetic();
    initStory(); S.words = $$('.w', S.lead || document.createElement('div'));
    initMenu(); initGreeting(); initMoments(); initDeliver(); initContact(); initShader();
    onScroll();
  }
  window.addEventListener('scroll', requestScroll, { passive: true });
  window.addEventListener('resize', requestScroll, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
